angular.module('tf.controllers')
    .controller('ScheduleController', ['$scope','$timeout','HttpService','ScheduleService','ProjectService','NotificationService','project',
        function ($scope, $timeout, HttpService, ScheduleService, ProjectService, NotificationService, project) {
            ScheduleService.get().then(function(res){
                console.log("Schedules: ", res.data);
            });

            if(ProjectService.project){
              //  ScheduleService.set(ProjectService.cleanProject(), new Date(), 60, 3);
            }

            $scope.dt = moment().add(3,'d');

            $scope.createSchedule = function () {
                NotificationService.popup('schedule',{dt : new Date()});
            };

            $timeout(function(){
                $('#datetimepicker1').datetimepicker({
                    inline: true,
                    sideBySide: true
                });
            },0);

        }]);